export default "__VITE_ASSET__34d23913__"